export enum PreferToCommunicate {
    YOUNGER = 'youngeer',
    PEERS = 'peers',
    OLDER = 'older',
}

export const preferToCommunicateTranslates = {
    [PreferToCommunicate.YOUNGER]: 'common:forms.labels.younger',
    [PreferToCommunicate.PEERS]: 'common:forms.labels.peers',
    [PreferToCommunicate.OLDER]: 'common:forms.labels.older',
};
